export default __webpack_public_path__ + "static/media/bell.34744660.svg";